import { useState, useEffect, useMemo } from 'react';
import type { CardFinish } from '../components/CollectionButton';
import { fetchBatchCardFinishes } from '../utils/cardPricing';

/**
 * Hook that batch-fetches available finishes for a list of card IDs.
 * Returns a Map from card_id to CardFinish[].
 * Re-fetches when the set of card IDs changes.
 */
export function useBatchCardFinishes(cardIds: string[]): Map<string, CardFinish[]> {
  const [finishMap, setFinishMap] = useState<Map<string, CardFinish[]>>(new Map());

  const stableKey = useMemo(() => {
    if (cardIds.length === 0) return '';
    return cardIds.slice().sort().join(',');
  }, [cardIds]);

  useEffect(() => {
    if (!stableKey) return;

    let cancelled = false;
    fetchBatchCardFinishes(cardIds).then(result => {
      if (!cancelled) setFinishMap(result);
    });

    return () => { cancelled = true; };
  }, [stableKey]);

  return finishMap;
}
